<template>
  <nuxt-child/>
</template>

<script>
  export default {
    meta: {
      title: 'Игры и категории'
    },
  }
</script>